export const TakeoffFormats = {
    Maestro:    { id: "1", text: "Maestro",               i18nKey: "Maestro" },
    ExtrAXION:  { id: "2", text: "ExtrAXION (Alconsoft)", i18nKey: "ExtraxionAlconsoft" },
    Other:      { id: "3", text: "Other",                 i18nKey: "Other" },
    Integrated: { id: "4", text: "Integrated",            i18nKey: "Integrated" },
}